export default "__VITE_ASSET__CketH2a0__"